import React from 'react';
import PageHeading from '@/components/common/PageHeading';
import Upload from '@/components/data/common/file/Upload';

export default function FileUploadPage() {
  return (
    <div className='workspace-management-page'>
      <PageHeading title='Import data' />
      <Upload />
    </div>
  );
}
